import { render, staticRenderFns } from "./icon-customer-light-post-solid-eye.vue?vue&type=template&id=2c2ff300&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports